import { __ } from '@wordpress/i18n';
import { useBlockProps, InspectorControls, InnerBlocks } from '@wordpress/block-editor';
import { PanelBody, RangeControl } from '@wordpress/components';

const Edit = ({ attributes, setAttributes }) => {
  const { height } = attributes;
  const blockProps = useBlockProps();

  return (
    <div {...blockProps}>
      <InspectorControls>
        <PanelBody title={__('Settings', 'custom')}>
          <RangeControl
            label={__('Height', 'custom')}
            value={height}
            onChange={(newHeight) => setAttributes({ height: newHeight })}
            min={200}
            max={800}
          />
        </PanelBody>
      </InspectorControls>
      <div className="slideshow-preview">
        <InnerBlocks
          allowedBlocks={['custom/slide']}
          template={[['custom/slide']]}
          templateLock={false}
          renderAppender={() => <InnerBlocks.ButtonBlockAppender />}
        />
      </div>
    </div>
  );
};

export default Edit;
